import { Pipe, PipeTransform } from '@angular/core';

import { PieceProductSettings } from 'extensions/core/piece-product/front/models/piece-product.models';
import { ProductColor, ProductSize } from 'idt-ecommerce-api/catalog/products/products.models';
import { PRODUCT_SIZE_ADDITIONAL_INFO_DEFAULT_VALUE } from 'shared/idt-components/idt-components-cms.model';
import { IdtComponent } from 'shared/models/idt-components/idt-component.models';


@Pipe({
  name: 'thresholdLabel'
})
export class ThresholdLabelPipe implements PipeTransform {

  public transform(
    value: string[],
    threshold: string,
    piece: IdtComponent<PieceProductSettings>,
    hasStock: boolean
  ): string {
    if (piece?.settings?.general.lastUnitsWarning && value?.includes(threshold) && hasStock) {
      return piece.settings.general.lastUnitsWarning;
    }
    return '';
  }

}

@Pipe({
  name: 'additionalInfo'
})
export class AdditionalInfoPipe implements PipeTransform {

  public transform(additionalInfo: string, piece: IdtComponent<PieceProductSettings>): string {
    if (piece?.settings?.general.additionalInfo) {
      const template = piece.settings.general.additionalInfo;
      return template.replace(/{{additionalInfo}}/g, additionalInfo);
    }
    return PRODUCT_SIZE_ADDITIONAL_INFO_DEFAULT_VALUE.replace(/{{additionalInfo}}/g, additionalInfo);
  }

}

@Pipe({
  name: 'viewSimilarProducts'
})
export class ViewSimilarProductsPipe implements PipeTransform {

  public transform(piece: IdtComponent<PieceProductSettings>, hasStock: boolean): string {
    if (piece?.settings?.general.viewSimilarProducts && !hasStock) {
      return piece.settings.general.viewSimilarProducts;
    }
    return '';
  }

}

@Pipe({
  name: 'colorSizes'
})
export class ColorSizesPipe implements PipeTransform {

  public transform(colors: ProductColor[], colorId?: string): ProductSize[] {
    const defaultSizes = colors[0].sizes || [];
    if (!colorId) {
      return defaultSizes;
    }
    return colors.find((color) => color.id === colorId)?.sizes || defaultSizes;
  }

}
